import { grey } from "@material-ui/core/colors";
import { createMuiTheme } from "@material-ui/core/styles";
const font = "'Quicksand', sans-serif";

export const mainFont = "'Audiowide', cursive";
export const secondaryFont = "'Source Code Pro', monospace";

const theme = createMuiTheme({
  palette: {
    type: "light",
    primary: {
      light: grey[800],
      main: "#606060",
      dark: "#3D3D3D"
    },
    secondary: {
      light: "#959595",
      main: "#5CB8FF",
      dark: "#2e2e2e"
    },
    error: {
      main: "#8b0000"
    },
    warning: {
      main: "#FF5454"
    },
    info: {
      main: "#000"
    },
    success: {
      main: "#5CB8FF"
    },
    text: {
      primary: "#fff",  // Styles TextField border and input text
      secondary: "#000",  // Styles TextField placeholder
      disabled: "#959595",
      hint: "#4FFC32"
    },
    divider: grey[500],
    background: {
      default: "#3D3D3D",
      paper: "#3D3D3D"
    }
  },
  typography: {
    fontFamily: font,
    button: {
      // textTransform: "none"
    }
  },
});

export default theme;
